import { moneySymbol } from 'src_common/common/amount/website-money/currency';
import config from '../config';

export function money(amount, currency) {
    let result = '';

    if (amount === null || amount === undefined || isNaN(amount)) {
        return 'n/a';
    }
    if (currency === undefined) {
        return `${result}${(amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
    }

    currency = currency.hasOwnProperty('size') ? currency.toJS().value : (typeof currency === 'string' ? currency : currency.value);
    const currencySign = moneySymbol(currency);

    if (amount < 0) {
        result = '-';
        amount = Math.abs(amount);
    }


    if (currency === 'BTC') {
        return `${result}${currencySign} ${amount.toFixed(8)}`;
    } else {
        return `${result}${currencySign}${(amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
    }
}

export function toCommaNumber(value) {
    return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function prepareDecimalFields(data, fields, operation, forceInteger = false) {
    Object.keys(data).map(fieldName => {
        if (fields.indexOf(fieldName) !== -1) {
            switch (operation) {
            case '*' :
                data[fieldName] = forceInteger ? parseInt(data[fieldName] * 100) : data[fieldName] * 100;
                break;
            case '/' :
                data[fieldName] = forceInteger ? parseInt(data[fieldName] / 100) : data[fieldName] / 100;
                break;
            default:
                // eslint-disable-next-line no-self-assign
                data[fieldName] = forceInteger ? parseInt(data[fieldName]) : data[fieldName];
            }

        }
    });
    return data;
}

export const CurrencySign = (currency) => {
    return config.symbols[currency] ?? '';
};
